import {
  InstallationStatusName,
  useGetInstallationGeneralDetailQuery
} from 'generated/graphql';

import React from 'react';

export interface IData {
  id: string;
  name: string;
  type: string;
  area: string;
  clientSelection: InstallationStatusName;

}

export function useQuery(id: string) {
  const tuple = useGetInstallationGeneralDetailQuery({
    variables: {
      id: id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.installation?.id ?? '',
        name: tuple.data?.installation?.name ?? '',
        type: tuple.data?.installation?.installationType.displayName ?? '',
        area: tuple.data?.installation?.fullAreaName ?? '',
        clientSelection: tuple.data?.installation?.isComplete ? 'complete' : 'inProgress'
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
